<template>
    <div class="longfigure-box">
        <Title :title="long.title"/>
        
        <div class="img-box">
            <img
            :src="long.img"
            lazy>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Longfigure',
    props: ['long']
}
</script>

<style scoped>
.img-box {
    height: 500px;
    overflow: scroll;
    overflow-x: hidden;
}

.img-box img {
    width: 100%;
}
</style>
